module.exports = __webpack_public_path__ + "img/avatar5.b3f7c3f4.png";